/**
 * This route is dynamically added to the app if this section is
 * enabled inside the config for the tenant being built.
 */
// @ngInject
function states($stateProvider) {
  $stateProvider.state('hub-register', {
    url: '/hub/register',
    templateUrl: 'apps/register-hub/templates/acp-register-hub.ng.html',
    controller: function() {},
    data: {
      permissions: {
        only: 'isHubRegistrationEnabled',
        except: 'password',
        redirectTo: {
          password: 'dashboard',
          isHubRegistrationEnabled: 'login'
        }
      }
    },
    resolve: {
      module: /* @ngInject */ function($ocLazyLoad) {
        return import(/* webpackChunkName: "acp.section.register-hub" */ 'apps/register-hub').then(
          $ocLazyLoad.loadModule
        );
      }
    }
  });
}

export default states;
